import { ChangeDetectorRef, Component, Inject, Injectable } from "@angular/core";
import {
    DwColumnFormatType, DwColumnRendererParams, DwDecoratorType, DwGridColumn, DwGridColumnDef, DwGridColumnRendererBase,
    getDefaultColumnStyle, DwEventService, DwGridColumnBaseComponent, DwMetaDataService, DwMetaDataServiceToken, DwLookupInfo
} from "@devwareapps/devware-cap";
import { BillingEntity, ProjectKickoffMetaDataItemNames } from "../meta-data/projectkickoff-meta-data.service";
import { AppMetaDataLookups } from "../../../meta-data/app-meta-data.service";

@DwGridColumn({
    keyName: 'project-kickoff-billing-departments-column2',
    display: 'Kickoff - Billing Departments (Component)',
    decoratorType: DwDecoratorType.component,
    isGlobal: false,
    parentItemName: [ProjectKickoffMetaDataItemNames.Billing],
    allowAttr: false,
    requireAttr: false,
    allowAction: true,
    order: 1,
    columnStyleFunc: getDefaultColumnStyle,
})
@Component({
    selector: 'app-kickoff-billing-departments-column',
    template: `
        {{billingDepartments}}
    `
})
export class KickoffBillingDepartmentsColumnComponent extends DwGridColumnBaseComponent {

    billingDepartments: string = 'Retrieving';
    allDepartments: DwLookupInfo[];

    constructor(
        private dwEventService: DwEventService,
        @Inject(DwMetaDataServiceToken) protected dwMetaDataService: DwMetaDataService,
        private cdr: ChangeDetectorRef
    ) {
        super();
        this.loadDepartments();
    }

    setupColumn() {
        if (!this.allDepartments)
            return;
        const departmentIds = this.params.data
                                  ?.BillingDepartment?.filter(i => !i._isDeleted)
                                  ?.map(pt => parseInt(pt.WachterDepartmentId)) || [];
        const items = this.allDepartments.filter(d => departmentIds.find(id => id == parseInt(d.Id)));
        this.billingDepartments = items.map(i => i.Display).join(', ');
        this.cdr.detectChanges();
    }

    private loadDepartments() {
        this.dwMetaDataService.getLookup(AppMetaDataLookups.EthosWachterDepartmentAllItems)
            .subscribe((allDepartments) => {
                this.allDepartments = allDepartments;
                this.setupColumn();
            });
    }
}